import DOMPurify from 'dompurify';

/**
 * Tag/attribute allowlist for Protocol section HTML — matches exactly what
 * Canvas Mode styles (DocumentEditor.jsx's `& h1, & h2, ... & table, & th, & td` sx hooks).
 * Anything else (stray <div>/<span>/style attrs from contentEditable paste, etc.) is stripped.
 */
const ALLOWED_TAGS = [
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'p', 'ul', 'ol', 'li',
  'table', 'thead', 'tbody', 'tr', 'th', 'td',
  'br', 'strong', 'em',
];

export function sanitizeSectionHtml(html) {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: [],
  });
}
